<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 2; backdrop-filter: blur(2px)"
      v-if="loaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container bluebtn">
      <div class="cf-header">Onboarding Documents</div>
      <div class="ct-main-container">
        <div class="ct-left-container mt-2">
          <div class="ct-table-top">
            <div class="ct-table-head-txt pl-2">List of Documents</div>
          </div>
          <div class="ct-table-container" style="height: calc(100vh - 230px)">
            <div class="ct-table-head mt-4 mb-2">
              <div class="w-4"></div>
              <div
                class="d-flex align-items-center w-96 ct-right-head-back mr-2"
              >
                <div class="w-25 pl-3">Document Name</div>
                <div class="w-20">Type</div>
                <div class="w-15">Required</div>
                <div class="w-20">Fill and Upload</div>
                <div class="w-10"></div>
                <div class="w-10"></div>
              </div>
            </div>

            <div class="ct-table-body pr-2" style="height: calc(100vh - 300px)">
              <div class="pl-4 ml-4 mt-2 mb-2">
                <span class="ct-table-bold-txt-3">Pre-defined Documents</span>
              </div>
              <div v-if="preDefinedDocs.length === 0" class="ct-table-row mb-2">
                <div class="w-4"></div>
                <div class="d-flex align-items-center w-96 ct-right-table-back">
                  <div class="cf-light-txt w-100 text-center">
                    No documents have been added in pre-defined documents
                  </div>
                </div>
              </div>
              <template v-else>
                <div
                  v-for="(doc, i) in preDefinedDocs"
                  :key="doc.key"
                  class="ct-table-row mb-2"
                >
                  <div class="w-4"></div>
                  <div
                    :style="
                      preDefinedEdit === i
                        ? 'background-color : #E1EEF7 !important;'
                        : ''
                    "
                    class="d-flex align-items-center w-96 ct-right-table-back"
                  >
                    <div class="ct-table-bold-txt w-25 pl-3">
                      {{ doc.label }}
                    </div>
                    <div class="ct-table-bold-txt-2 w-20">
                      {{ doc.fileFormat.join(", ") }}
                    </div>
                    <div class="w-15 ct-table-switch">
                      <b-form-checkbox
                        disabled
                        switch
                        v-model="doc.mandatory"
                      ></b-form-checkbox>
                    </div>
                    <div class="ct-table-bold-txt-2 w-20">
                      {{ doc.downloadTemplate ? "Yes" : "No" }}
                    </div>
                    <div
                      class="
                        w-20
                        d-flex
                        align-items-center
                        justify-content-end
                        mr-3
                      "
                    >
                      <template v-if="roles.includes('PUT_DOCUMENT')">
                        <img
                          v-if="preDefinedEdit === i"
                          class="mr-2 disable-inputField"
                          src="../../assets/customfield/disableblueedit.svg"
                          alt=""
                        />
                        <img
                          v-else
                          @click="editDocument(doc, 'predefined', i)"
                          class="mr-2 pointer"
                          src="@/assets/customfield/blueEdit.svg"
                          alt=""
                        />
                      </template>
                      <template v-if="roles.includes('DELETE_DOCUMENT')">
                        <img
                          v-if="preDefinedEdit === i"
                          class="disable-inputField"
                          height="25"
                          width="25"
                          src="../../assets/customfield/disableddelete.svg"
                          alt=""
                        />
                        <img
                          v-else
                          @click="deleteDocument(doc, 'predefined', i)"
                          class="pointer"
                          src="@/assets/customfield/blueDelete.svg"
                          alt=""
                        />
                      </template>
                    </div>
                  </div>
                </div>
              </template>
              <hr />
              <div class="pl-4 ml-4 mb-2">
                <span class="ct-table-bold-txt-3">Custom Documents</span>
              </div>
              <div v-if="customDocs.length === 0" class="ct-table-row mb-2">
                <div class="w-4"></div>
                <div class="d-flex align-items-center w-96 ct-right-table-back">
                  <div class="cf-light-txt w-100 text-center">
                    No documents have been added in custom fields
                  </div>
                </div>
              </div>

              <template v-else>
                <div
                  v-for="(doc, i) in customDocs"
                  :key="doc.key"
                  class="ct-table-row mb-2"
                >
                  <div class="w-4"></div>
                  <div
                    :style="
                      customEdit === i
                        ? 'background-color : #E1EEF7 !important;'
                        : ''
                    "
                    class="d-flex align-items-center w-96 ct-right-table-back"
                  >
                    <div class="ct-table-bold-txt w-25 pl-3">
                      {{ doc.label }}
                    </div>
                    <div class="ct-table-bold-txt-2 w-20">
                      {{ doc.fileFormat.join(", ") }}
                    </div>
                    <div class="w-15 ct-table-switch">
                      <b-form-checkbox
                        v-model="doc.mandatory"
                        disabled
                        switch
                      ></b-form-checkbox>
                    </div>
                    <div class="ct-table-bold-txt-2 w-20">
                      {{ doc.downloadTemplate ? "Yes" : "No" }}
                    </div>
                    <div
                      class="
                        w-20
                        d-flex
                        align-items-center
                        justify-content-end
                        mr-3
                      "
                    >
                      <img
                        v-if="!doc.downloadTemplate || customEdit === i"
                        class="mr-2 disable-inputField"
                        src="@/assets/img/hrdocuments/disable-view-docs.svg"
                        alt=""
                      />
                      <img
                        v-else
                        @click="viewTemplate(doc, i)"
                        class="mr-2 pointer"
                        src="@/assets/img/hrdocuments/view-docs.svg"
                        alt=""
                      />
                      <template v-if="roles.includes('PUT_DOCUMENT')">
                        <img
                          v-if="customEdit === i"
                          class="mr-2 disable-inputField"
                          src="../../assets/customfield/disableblueedit.svg"
                          alt=""
                        />
                        <img
                          v-else
                          @click="editDocument(doc, 'custom', i)"
                          class="mr-2 pointer"
                          src="@/assets/customfield/blueEdit.svg"
                          alt=""
                        />
                      </template>
                      <template v-if="roles.includes('DELETE_DOCUMENT')">
                        <img
                          v-if="customEdit === i"
                          class="disable-inputField"
                          height="25"
                          width="25"
                          src="../../assets/customfield/disableddelete.svg"
                          alt=""
                        />
                        <img
                          v-else
                          @click="deleteDocument(doc, 'custom', i)"
                          class="pointer"
                          src="@/assets/customfield/blueDelete.svg"
                          alt=""
                        />
                      </template>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <AddDocument
          :action="action"
          :type="type"
          :requiredDocuments="requiredDocuments"
          :document="document"
          :licenseKey="licenseKey"
          @change-type="changeTypeData"
          @show-screen="onShowScreen"
          :nameList="nameList"
          @refresh-table="
            clearSelected();
            getDocumentsTable();
          "
        />
      </div>
    </div>
    <ConfirmModal
      v-if="confirmModal"
      @close-modal="
        clearSelected();
        confirmModal = false;
      "
      @handle-submit="deleteDocuments"
      :confirmModal="confirmModal"
      button="Delete"
      header="Delete Document"
      msg="Are you sure you want to delete this document?"
      :imageSrc="
        require('@/assets/img/newworkbench/internalhiring/closeJob-delete.svg')
      "
    />

    <ViewResume
      v-if="viewDocument"
      :label="document.label"
      :showModal="viewDocument"
      :link="document.templateLinks[0]"
      from="onboardDoc"
      @close-modal="(viewDocument = false), clearSelected()"
    />
  </div>
</template>

<script>
import {
  getDocumentsTable,
  getRequiredDocuments,
  deleteDocuments,
} from "@/utils/apiFunctions";
import toast from "@/components/mixin/toast";
import AddDocument from "./AddDocument.vue";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import ConfirmModal from "../InterviewProcess/ConfirmModal.vue";
import { mapGetters } from "vuex";
import ViewResume from "../../components/modals/viewResume.vue";

export default {
  components: {
    AddDocument,
    Spinner,
    ConfirmModal,
    ViewResume,
  },
  mixins: [toast],
  data() {
    return {
      // BOOLEAN
      loaderStatus: false,
      confirmModal: false,
      viewDocument: false,

      // NUMBERS
      preDefinedEdit: null,
      customEdit: null,
      currentPage: 1,
      numPages: 0,
      perPage: 1,

      // STRINGS
      action: "home",
      type: "",
      licenseKey: "",

      // ARRAYS
      requiredDocuments: [],
      preDefinedDocs: [],
      customDocs: [],
      nameList: [],

      // OBJECTS
      document: {},
    };
  },
  async created() {
    this.loaderStatus = true;
    await this.getRequiredDocuments();
    this.getDocumentsTable();
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  methods: {
    changeTypeData(value) {
      this.type = value;
    },
    async getRequiredDocuments() {
      try {
        let res = await getRequiredDocuments();
        if (res.status === 200) {
          this.requiredDocuments = res.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getDocumentsTable() {
      try {
        this.loaderStatus = true;
        let payload = {
          parentID: 6,
        };
        let res = await getDocumentsTable(payload);
        if (res.status === 200) {
          let allDocs = res.data.data.fields;
          this.licenseKey = res.data.data.licenseKey;
          this.preDefinedDocs = [];
          this.customDocs = [];
          allDocs.forEach((docs) => {
            if (docs.fieldType === "predefinedField") {
              this.preDefinedDocs.push(docs);
            } else if (docs.fieldType === "customField") {
              this.customDocs.push(docs);
            }
          });
          this.setPredefinedFields();
          this.loaderStatus = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    setPredefinedFields() {
      const preDefinedKeys = new Set(this.preDefinedDocs.map((doc) => doc.key));
      this.requiredDocuments = this.requiredDocuments.filter(
        (doc) => !preDefinedKeys.has(doc.key)
      );
      this.$forceUpdate();
    },
    getDocumentList() {
      this.nameList = [];
      this.preDefinedDocs.forEach((doc) => {
        this.nameList.push(doc.label);
      });
      this.customDocs.forEach((doc) => {
        this.nameList.push(doc.label);
      });
    },
    onShowScreen(action, type) {
      this.getDocumentList();
      this.setPredefinedFields();
      this.action = action;
      this.type = type;
      this.preDefinedEdit = null;
      this.customEdit = null;
    },
    clearSelected() {
      this.document = {};
      this.preDefinedEdit = null;
      this.customEdit = null;
      this.action = "home";
    },
    editDocument(doc, type, i) {
      if (type === "custom") {
        this.getDocumentList();
        this.customEdit = i;
        this.preDefinedEdit = null;
      } else {
        this.preDefinedEdit = i;
        this.customEdit = null;
      }
      this.document = JSON.parse(JSON.stringify(doc));
      if (type == "predefined") {
        let data = {
          label: doc.label,
          key: doc.key,
        };
        this.requiredDocuments.push(data);
      }
      this.action = "";
      this.$nextTick(() => {
        this.action = "edit";
      });
      this.type = type;
      this.$forceUpdate();
    },
    viewTemplate(doc, i) {
      this.document = doc;
      this.customEdit = i;
      this.preDefinedEdit = null;
      this.viewDocument = true;
    },
    deleteDocument(doc, type, i) {
      this.customEdit = null;
      if (type === "custom") {
        this.customEdit = i;
        this.preDefinedEdit = null;
      } else {
        this.preDefinedEdit = i;
        this.customEdit = null;
      }
      this.document = doc;
      this.confirmModal = true;
    },
    async deleteDocuments() {
      try {
        let payload = {
          key: this.document.key,
          parentID: 6,
        };
        let res = await deleteDocuments(payload);
        if (res.status === 200) {
          this.confirmModal = false;
          this.successModal("Document has been successfully deleted");
          this.clearSelected();
          this.getDocumentsTable();
          this.getRequiredDocuments();
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped></style>
